export default "__VITE_ASSET__BEVEoIDa__"